import React from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const TerminalIndicator = ({terminal}) => (
    terminal ? (
        <span className="text-danger">
            <FontAwesomeIcon icon="flag-checkered" />
        </span>
    ) : null
);

TerminalIndicator.propTypes = {
    terminal: PropTypes.bool,
};

export default TerminalIndicator;
